var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.90152C0 5.71211 0.079009 5.53047 0.219646 5.39654C0.360282 5.2626 0.551026 5.18736 0.749916 5.18736H9.43845L6.21831 2.1222C6.07749 1.9881 5.99838 1.80622 5.99838 1.61658C5.99838 1.42693 6.07749 1.24506 6.21831 1.11096C6.35912 0.976856 6.5501 0.90152 6.74925 0.90152C6.94839 0.90152 7.13937 0.976856 7.28019 1.11096L11.7797 5.3959C11.8495 5.46224 11.9049 5.54104 11.9427 5.62781C11.9805 5.71457 12 5.80758 12 5.90152C12 5.99546 11.9805 6.08847 11.9427 6.17523C11.9049 6.262 11.8495 6.3408 11.7797 6.40714L7.28019 10.6921C7.13937 10.8262 6.94839 10.9015 6.74925 10.9015C6.5501 10.9015 6.35912 10.8262 6.21831 10.6921C6.07749 10.558 5.99838 10.3761 5.99838 10.1865C5.99838 9.99682 6.07749 9.81494 6.21831 9.68084L9.43845 6.61568H0.749916C0.551026 6.61568 0.360282 6.54044 0.219646 6.40651C0.079009 6.27258 0 6.09093 0 5.90152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white",
    transform: "translate(0 0.90152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.7f7f244910f187a1dd0355f1cbf9b256.svg";
export { ForwardRef as ReactComponent };